import celebration from "@/assets/dr-sara-instagram-1m.jpg.asset.json";
import { btn, eyebrow, sectionTitle } from "@/components/ds/styles";
import { INSTAGRAM_HANDLE, instagramUrl } from "@/lib/social";

export function InstagramSection({ instagramSetting }: { instagramSetting?: string | null }) {
  return (
    <section aria-labelledby="instagram-title" className="reveal mx-3 grid gap-7 rounded-ds-2xl bg-maroon-100 px-6 py-9 lg:mx-auto lg:max-w-[76rem] lg:grid-cols-2 lg:items-center lg:gap-12 lg:px-12 lg:py-14">
      <img
        src={celebration.url}
        alt="د. سارة النحّاس تحتفل بمليون متابع على إنستغرام"
        width={680}
        height={850}
        loading="lazy"
        decoding="async"
        className="aspect-[4/3] w-full rounded-ds-xl object-cover object-[50%_20%] lg:aspect-[4/5]"
      />
      <div className="min-w-0">
        <p className={eyebrow}>إنستغرام</p>
        <h2 id="instagram-title" className={sectionTitle + " mt-2"}>مليون متابع، ومليون شكر</h2>
        <p className="mt-4 text-[17px] leading-[1.85] text-text-secondary">مجتمع من الأهل بيتابع ويسأل ويشارك. نصائح ومقاطع قصيرة من د. سارة، بلغة بسيطة وقريبة من البيت.</p>
        <p dir="ltr" className="mt-4 text-end font-display text-[15px] font-bold text-text-secondary">{INSTAGRAM_HANDLE}</p>
        <a href={instagramUrl(instagramSetting)} target="_blank" rel="noopener noreferrer" className={btn.primary + " mt-6 w-full px-4 lg:w-auto"}>
          متابعة د. سارة على إنستغرام ↖
        </a>
      </div>
    </section>
  );
}